// Super-admin only endpoints. The API enforces ROLE_SUPER_ADMIN on every one of
// these; the frontend only hides the pages.
const AdminEndpoints = {
  users: {
    // user_id, email, roles, email_validated, paid_til (General group), post/schedule counts
    list: "/superadmin/getpostcountbyuser",
    // PUT {paid_til: "2027-01-31" | "+3 months", group?: "General"} — sets
    // Group::paidTil and persists/revokes ROLE_PAYED_USER accordingly.
    paidTil: (userId) => `/admin/users/${userId}/paidtil`,
    // POST, no body — validates the email and creates the system groups of a
    // user that never confirmed the signup mail. No-op for active users.
    activate: (userId) => `/admin/users/${userId}/activate`,
  },
};

export default AdminEndpoints;
